import { useCallback } from "react";
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  ANALYTICS_EVENT,
  ANALYTICS_PAGE_TYPE,
  ANALYTICS_SEARCH_TYPE,
  ANALYTICS_USER_TYPE,
} from "../constants";

import { Variant } from '../constants/variants';

interface IAnalytics {
  event: ANALYTICS_EVENT;
  page?: ANALYTICS_PAGE_TYPE;
  user?: ANALYTICS_USER_TYPE;
  search?: ANALYTICS_SEARCH_TYPE;
  country?: string;
  category?: string;
  make?: string;
  model?: string;
  query?: string;
  oilName?: string,
  oilCategory?: string,
  button?: string,
  recommendation?: string,
  serviceType?: string,
  serviceOutlet?: string,
}


export function useAnalytics() {
  const countryFromStore = useSelector((state: any) => state.country);
  const countryCode = countryFromStore.isoCode;
  const [ searchParams ] = useSearchParams();
  const variant = searchParams.get('variant');
  const isFord = variant === Variant.FORD;
  // eslint-disable-next-line sonarjs/cognitive-complexity
  return useCallback((analytics: IAnalytics) => {
    const { event, page, user, search, country, category, make, model, query, oilName, oilCategory, button, recommendation, serviceType, serviceOutlet} = analytics;
    if ("dataLayer" in window) {
      const layer: any = window.dataLayer;
      layer.push({
        event: event,
        countryCode: country ?? countryCode,
        ...(page && {
          pageType: page,
        }),
        ...(search && {
          searchType: search,
        }),
        ...(user && {
          userType: user,
        }),
        ...(category && {
          vehicleCategory: category.trim(),
        }),
        ...(make && {
          vehicleMake: make.trim(),
        }),
        ...(model && {
          vehicleModel: model.trim(),
        }),
        ...(query && {
          searchQuery: query.toLowerCase().trim(),
        }),
        ...(oilName && {
          oilName: oilName.trim(),
        }),
        ...(oilCategory && {
          oilCategory: oilCategory.trim(),
        }),
        ...(button && {
          buttonName: button.trim(),
        }),
        ...(recommendation && {
          recommendationType: recommendation.trim(),
        }),
        ...(serviceType && {
          serviceType: serviceType.trim(),
        }),
        ...(serviceOutlet && {
          serviceOutlet: serviceOutlet.trim(),
        }),
        ...(isFord && {
          variant: variant
        })
      });
    }
  }, [countryFromStore, variant]);
}
